import React, { useState, useRef, useEffect } from 'react'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'

const FAQ = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const answerRef = useRef(null);
  const [maxH, setMaxH] = useState('0px');

  /* Dynamic max-height — measures actual content, never clips */
  useEffect(() => {
    if (open && answerRef.current) {
      setMaxH(answerRef.current.scrollHeight + 'px');
    } else {
      setMaxH('0px');
    }
  }, [open]);

  const toggle = () => setOpen(prev => !prev);

  return (
    <article
      className={`faq${open ? ' active' : ''}`}
      onClick={toggle}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }}
      tabIndex={0}
      role="button"
      aria-expanded={open}
    >
      <div className="faq__header">
        <div className="faq__question">{question}</div>
        {/* stopPropagation prevents double-toggle from article onClick */}
        <span
          className="faq__icon"
          onClick={e => { e.stopPropagation(); toggle(); }}
          aria-hidden="true"
        >
          {open ? <AiOutlineMinus /> : <AiOutlinePlus />}
        </span>
      </div>
      <div className="faq__answer" ref={answerRef} style={{ maxHeight: maxH }}>
        <p>{answer}</p>
      </div>
    </article>
  )
}

export default FAQ